// src/components/sections/ProgramsSection/ProgramsSection.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './ProgramsSection.css';
import { events } from '../../../data/programsData';
import { compareAsc, endOfDay } from 'date-fns';

const getNextThreeEvents = () => {
  const now = new Date();
  const futureEvents = events
    .flatMap(yearData => yearData.items)
    .filter(event => endOfDay(new Date(event.endDate)) >= now)
    .sort((a, b) => compareAsc(new Date(a.startDate), new Date(b.startDate)));
  return futureEvents.slice(0, 3);
};

const ProgramsSection = () => {
  const nextEvents = getNextThreeEvents();

  return (
    <section id="programacao" className="section programs-section-reborn">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Agenda Exclusiva</span>
          <h2 className="section-title">Experiências Únicas em Nosso Hotel</h2>
          <p className="section-subtitle">
            Muito além da hospedagem, o Alzira Imperial Hotel oferece uma agenda de eventos completa para enriquecer sua visita. De festivais a shows intimistas, sempre há algo especial acontecendo aqui.
          </p>
        </div>

        <div className="events-grid">
          {nextEvents.map(event => (
            // --- ALTERAÇÃO AQUI: O card agora é um Link ---
            <Link to={`/programacaocompleta#evento-${event.id}`} key={event.id} className="event-card">
<div className="event-card-image" style={{ backgroundImage: `url('${process.env.PUBLIC_URL}${event.image}')` }}>                <div className="event-card-category">{event.category}</div>
              </div>
              <div className="event-card-content">
                <p className="event-card-date">{event.dateString}</p>
                <h3 className="event-card-title">{event.title}</h3>
                <p className="event-card-description">{event.description}</p>
              </div>
            </Link>
          ))}
        </div>

        {nextEvents.length > 0 && (
          <div className="view-all-container">
            <Link to="/programacaocompleta" className="btn btn-primary">
              Ver Programação Completa
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgramsSection;